"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigation = void 0;
const utils_1 = require("core/utils");
const react_router_1 = require("react-router");
const useAmpli_1 = require("./useAmpli");
const useNavigation = () => {
    const history = (0, react_router_1.useHistory)();
    const location = (0, react_router_1.useLocation)();
    const goToClassicLogin = () => {
        (0, utils_1.redirectToClassic)('/login/signin');
    };
    const goToClassicFindTeam = () => {
        (0, utils_1.redirectToClassic)('/login/find_my_team');
    };
    const goToClassicSignup = () => {
        (0, utils_1.redirectToClassic)('/signup/missing_email');
    };
    const goToClassicNewTeam = () => {
        (0, utils_1.redirectToClassic)('/team/new');
    };
    return {
        navigate: {
            v1Start: (state) => {
                history.replace({ pathname: '/signup', state });
            },
            v1RoleSelect: (state) => {
                history.replace({ pathname: '/team/role', state });
            },
            v1CreateTeam: (state) => {
                history.push({ pathname: '/team/new', state });
            },
            v1TeamPlan: (teamId, state) => {
                history.replace({ pathname: `/team/${teamId}/plan`, state });
            },
            v1TeamPlanNew: (teamId, state, search) => {
                history.replace({ pathname: `/team/${teamId}/plan/new`, search, state });
            },
            v1TeamPlanManage: (teamId, state) => {
                history.replace({ pathname: `/team/${teamId}/plan/manage`, state });
            },
            v1InviteRole: (invitationCode, state) => {
                history.replace({
                    pathname: `/invitations/${invitationCode}/role`,
                    state,
                });
            },
            v1InviteClaim: (invitationCode, state) => {
                history.replace({
                    pathname: `/invitations/${invitationCode}/claim`,
                    state,
                });
            },
            v1InviteRoster: (invitationCode, state) => {
                history.replace({
                    pathname: `/invitations/${invitationCode}/complete_roster`,
                    state,
                });
            },
            v1InviteTsPlusOffer: (invitationCode, state) => {
                history.replace({
                    pathname: `/invitations/${invitationCode}/offer`,
                    state,
                });
            },
            v1InviteTsPlusOfferNew: (invitationCode, state) => {
                history.replace({
                    pathname: `/invitations/${invitationCode}/offer/new`,
                    state,
                });
            },
            chooseFreePlan: (teamId) => {
                (0, utils_1.redirectToClassic)(`/${teamId}/team_setup?onboarding_return=true&free_plan=true`);
            },
            classicTeamSetup: (teamId) => {
                (0, utils_1.redirectToClassic)(`/${teamId}/team_setup?onboarding_return=true`);
            },
            classicTeamBilling: () => {
                (0, utils_1.redirectToClassic)(`/account?view=billing&updated=true`);
            },
            goToClassicTeamPlan: (teamId) => {
                (0, utils_1.redirectToClassic)(`/account/${teamId}/select_plan`);
            },
            continueInviteClassic: async (invitationCode) => {
                await (0, useAmpli_1.flushAmpli)();
                (0, utils_1.redirectToClassic)(`/invitations/${invitationCode}/edit?onboarding_return=true`);
            },
            goToClassicLogin,
            goToClassicFindTeam,
            goToClassicSignup,
            goToClassicNewTeam,
        },
        getState: (key) => location.state?.[key],
    };
};
exports.useNavigation = useNavigation;
